import React, {useState} from 'react';
import {Backdrop, Button, Fade, Grid, Modal} from "@mui/material";
import NautilusTextInput from "../../Common/NautilusTextInput";
import {requestLoader, showAlertAutoDis} from "../../../utils/utils";

const LoginForm = ({handleForm,customer,classes, widget = false}) => {
    const [forgot, setForgot] = useState(false);
    const [fState, setFState] = useState({identity: ''});
    const closeForgot = () => {
        setForgot(false);
    }
    const openForgot = () => {
        setForgot(true);
    }
    const onSubmitRequest = async (e) => {
        e.preventDefault();
        const url = "/auth/forgot_password_ajax";
        await requestLoader(url, fState, ({data: {title, text}}) => {
            closeForgot();
            showAlertAutoDis({title, text});
        });
    }
    const handleFChange = (event) => {
        setFState({...fState, [event.target.name]: event.target.value});
    }
    return (
        <form className={'loginCustomerForm'} noValidate autoComplete="off">
            <Grid container direction="row" justify="center" alignItems="center"
                  style={{paddingTop: 30, paddingBottom: 30}}>
                <Grid item sm={6} xs={12} style={{padding: 10}}>
                    <NautilusTextInput fullWidth name="email" value={customer['email']}
                                       onChange={handleForm} label="Email" variant="outlined"/>
                </Grid>
                <Grid item sm={6} xs={12} style={{padding: 10}}>
                    <NautilusTextInput fullWidth name="password" value={customer['password']}
                                       onChange={handleForm} type="password"
                                       autoComplete="current-password" label="Password"
                                       variant="outlined"/>
                </Grid>
                <Grid item xs={12}>
                    <h4>Do you need help?
                        <br/>
                        <small> <a href="/booking/forgot_password" target="_blank">Forgot your password?</a></small>
                    </h4>

                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={forgot}
                        onClose={() => closeForgot()}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={forgot}>
                            <div className={classes.paper}>
                                <h1>Forgot Password</h1>
                                <p className="center">It happens to the best of us. Enter your email
                                    below and we will send you a reset link.</p>
                                <form className={'loginCustomerForm'} onSubmit={onSubmitRequest}
                                      acceptCharset="utf-8" noValidate autoComplete="off">
                                    <Grid container direction="row" justify="center" alignItems="center"
                                          style={{paddingTop: 30, paddingBottom: 30}}>
                                        <Grid item xs={12} style={{padding: 10}}>
                                            <NautilusTextInput fullWidth name="identity"
                                                               value={fState['identity']}
                                                               onChange={handleFChange} label="Email"
                                                               type={'email'}/>
                                        </Grid>
                                        <Grid item xs={12} style={{padding: 10}}>
                                            <Button variant="contained" color="yellow" type={"submit"}>
                                                I forgot my password
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </div>
                        </Fade>
                    </Modal>
                </Grid>
            </Grid>
        </form>
    );
};

export default LoginForm;
